// From webpack build
declare const SUPPORTED_BROWSER_REGEX: RegExp

export const isSupportedBrowser = SUPPORTED_BROWSER_REGEX.test(
  window.navigator.userAgent
)
